<template>
    <v-card elevation="0">
        <v-card class="px-4 mt-4" elevation="0">
            <v-row>
                <v-col md="12" class="mb-1 mt-1">
                    <h4 class="font-weight-light primary--text">
                        Datos Básicos
                    </h4>
                </v-col>
            </v-row>
            <!-- <v-divider></v-divider> -->
            <v-row class="mb-n7 mt-n2">
                <v-col cols="12" md="10">
                    <v-row>
                        <v-col md="4" cols="12">
                            <v-text-field v-model="name" label="Nombre" style="padding: 21.1px 0px 17px 0px">
                            </v-text-field>
                        </v-col>
                        <v-col md="2" cols="12">
                            <v-select clearable chips hide-selected :items="opciones.tarifas.operator" item-text="human"
                                item-value="encoded" v-model="operator" label="Operador">
                                <template #selection="{ item }">
                                    <v-chip color="primary" class="white--text">
                                        <v-icon> mdi-signal-variant </v-icon>
                                        {{ item.encoded }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>

                        <v-col v-if="!$vuetify.breakpoint.mdAndDown" cols="2">
                            <v-select clearable hide-selected chips :items="Families" v-model="category"
                                label="Familia">
                                <template #selection="{ item }">
                                    <v-chip color="purple" class="white--text">
                                        <v-icon> mdi-family-tree </v-icon>
                                        {{ item }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>

                        <v-col v-if="$vuetify.breakpoint.mdAndDown" cols="12">
                            <v-select clearable hide-selected chips :items="Families" v-model="category"
                                label="Familia">
                                <template #selection="{ item }">
                                    <v-chip color="purple" class="white--text">
                                        <v-icon> mdi-family-tree </v-icon>
                                        {{ item }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>

                        <v-col md="2" cols="12">
                            <v-select clearable hide-selected chips :items="['postpaid', 'prepaid']"
                                v-model="payment_type" label="Tipo de pago">
                                <template #selection="{ item }">
                                    <v-chip color="orange darken-2" class="white--text">
                                        <v-icon> mdi-credit-card </v-icon>
                                        {{ item }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col md="2" cols="12">
                            <v-select clearable hide-selected chips :items="opciones.tarifas.segment" item-text="human"
                                item-value="encoded" v-model="segment" label="Segmento">
                                <template #selection="{ item }">
                                    <v-chip color="yellow darken-2" class="white--text">
                                        <v-icon> mdi-call-merge </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-col>
                <!--Desk view-->
                <v-col v-if="!$vuetify.breakpoint.mdAndDown" cols="2">
                    <v-row class="mb-n7 mt-n3">
                        <v-col md="6">
                            <v-text-field :disabled="formType != 'add'" v-model="price" label="Precio" required
                                style="padding: 21.1px 0px 12px 0px"></v-text-field>
                        </v-col>
                        <v-col md="6" style="padding: 21px 10px 0px 10px">
                            <v-select hide-selected :items="['€']" label="Unidad" value="€" disabled>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mdAndDown" cols="12">
                    <v-row class="mb-n7 mt-n3">
                        <v-col md="6">
                            <v-text-field :disabled="formType != 'add'" v-model="price" label="Precio" required
                                style="padding: 21.1px 0px 12px 0px"></v-text-field>
                        </v-col>
                        <v-col md="6" style="padding: 21px 10px 0px 10px">
                            <v-select hide-selected :items="['€']" label="Unidad" value="€" disabled>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>

        <v-row no-gutters :class="autoUpfront ? '' : 'd-flex justify-center'">
            <v-col :cols="payment_type != 'prepaid' ? '12' : '12'">
                <v-card class="pb-3 px-4 mt-3" elevation="0">
                    <v-row>
                        <v-col md="12" class="mb-1 mt-1">
                            <h4 class="font-weight-light primary--text">
                                Extras
                            </h4>
                        </v-col>
                    </v-row>
                    <!-- <v-divider></v-divider> -->
                    <v-row no-gutters>
                        <v-col xl="4" lg="4" md="4" cols="12" class="px-2">
                            <v-autocomplete style="margin-top: -11px" multiple chips :items="filteredPromotions"
                                item-text="name" item-value="id" v-model="SelectedPromotions" label="Promociones"
                                full-width>
                                <template #selection="{ item }">
                                    <v-chip @click:close="removePromo(item)" close color="pink" class="white--text">
                                        <v-icon> mdi-credit-card </v-icon>
                                        {{ item.name ? item.name : item.id }}
                                    </v-chip>
                                </template>
                                <template #item="{ item }">
                                    <v-row>
                                        <v-col cols="11">
                                            {{
                                            item && item.name
                                            ? item.name
                                            : item.id
                                            }}
                                        </v-col>
                                        <v-col cols="1" class="d-flex justify-center">
                                            <v-icon :color="
                                                    item.is_active
                                                        ? 'green'
                                                        : 'red'
                                                ">
                                                mdi-circle
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" cols="12" class="px-2">
                            <v-autocomplete clearable multiple chips :items="filteredAdditionals" item-text="name"
                                v-model="SelectedAditionals" label="Adicionales">
                                <template #selection="{ item }">
                                    <v-chip @click:close="removeAditionals(item)" close color="blue darken-3"
                                        class="white--text">
                                        <v-icon>
                                            mdi-puzzle-plus-outline
                                        </v-icon>
                                        {{ item.name }}
                                    </v-chip>
                                </template>
                                <template #item="{ item }">
                                    <v-row>
                                        <v-col cols="11">
                                            {{
                                            item && item.name
                                            ? item.name
                                            : item.id
                                            }}
                                        </v-col>
                                        <v-col cols="1" class="d-flex justify-center">
                                            <v-icon :color="
                                                    item.is_active
                                                        ? 'green'
                                                        : 'red'
                                                ">
                                                mdi-circle
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" cols="12" class="px-2">
                            <v-autocomplete clearable multiple chips :items="filteredSva" item-text="name"
                                item-value="id" v-model="SelectedSVA" label="SVA">
                                <template #selection="{ item }">
                                    <v-chip @click:close="removeSVA(item)" close color="amber darken-3"
                                        class="white--text">
                                        <v-icon>
                                            mdi-toy-brick-plus-outline
                                        </v-icon>
                                        {{ item.name ? item.name : item.id }}
                                    </v-chip>
                                </template>
                                <template #item="{ item }">
                                    <v-row>
                                        <v-col cols="8">
                                            {{
                                            item && item.name
                                            ? item.name
                                            : item.id
                                            }}
                                        </v-col>
                                        <v-col cols="3">
                                            {{
                                            item
                                            ? `${parseFloat(
                                            item.price
                                            ).toFixed(2)} €`
                                            : 'N/A'
                                            }}
                                        </v-col>
                                        <v-col cols="1" class="d-flex justify-center">
                                            <v-icon :color="
                                                    item.is_active
                                                        ? 'green'
                                                        : 'red'
                                                ">
                                                mdi-circle
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
// import {
//     OperatorErrors,
//     categoryErrors,
//     SelectedPaymentTypeErrors,
//     SelectedSegmentErrors,
//     nameErrors,
// } from './errorHandlers'
// import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex';

export default {
    name: 'ManagementBaseForm',
    data: () => ({
        details: false,
        autoUpfront: true,
        Families: ['convergent', 'mobile_line', 'fixed_line'],
        Colors: [
            'Blue',
            'Green',
            'Red',
            'Orange',
            'Purple',
            'Indigo',
            'Yellow ',
            'Pink',
            'Black',
            'Violet',
            'Lime',
        ],
    }),
    methods: {
        removePromo(item) {
            let index = this.SelectedPromotions.indexOf(item.id);
            this.SelectedPromotions.splice(index, 1);
        },
        removeAditionals(item) {
            let index = this.SelectedAditionals.indexOf(item.id);
            this.SelectedAditionals.splice(index, 1);
        },
        removeSVA(item) {
            let index = this.SelectedSVA.indexOf(item.id);
            this.SelectedSVA.splice(index, 1);
        },
        clearFields() {
            this.$store.state.ManagementBase.tariffManagement.isActive = false;
            this.$store.state.ManagementBase.tariffManagement.isAdditional = false;
            this.$store.state.ManagementBase.tariffManagement.commercial_enrichment =
                '';
            this.$store.state.ManagementBase.tariffManagement.description_file =
                '';
            this.$store.state.ManagementBase.tariffManagement.operator = '';
            this.$store.state.ManagementBase.tariffManagement.category = '';
            this.$store.state.ManagementBase.tariffManagement.payment_type = '';
            this.$store.state.ManagementBase.tariffManagement.segment = '';
            this.$store.state.ManagementBase.tariffManagement.name = '';
            this.$store.state.ManagementBase.tariffManagement.color = '';
            this.$store.state.ManagementBase.tariffManagement.FiberType = '';
            this.$store.state.ManagementBase.tariffManagement.Owner = [];
            this.$store.state.ManagementBase.tariffManagement.SelectedPromotions =
                [];
            this.$store.state.ManagementBase.tariffManagement.SelectedAditionals =
                [];
            this.$store.state.ManagementBase.tariffManagement.SelectedSVA = [];
            this.$store.state.ManagementBase.tariffManagement.MobileForeignMinuteQuantity = 0;
            this.$store.state.ManagementBase.tariffManagement.MobileNationalMinuteQuantity = 0;
            this.$store.state.ManagementBase.tariffManagement.LandLineToLandLineMinuteQuantity = 0;
            this.$store.state.ManagementBase.tariffManagement.LandLineToMobileMinuteQuantity = 0;
            this.$store.state.ManagementBase.tariffManagement.DataQuantity = 0;
            this.$store.state.ManagementBase.tariffManagement.MinuteQuantity = 0;
            this.$store.state.ManagementBase.tariffManagement.price = 0;
            // this.$store.state.ManagementBase.tariffManagement.Upfront = 0;
            this.$store.state.ManagementBase.tariffManagement.UploadSpeedQuantity = 0;
            this.$store.state.ManagementBase.tariffManagement.DownloadSpeedQuantity = 0;
            this.$store.state.ManagementBase.tariffManagement.content_type =
                null;
        },
        closeForm() {
            this.$store.commit(
                'ManagementBase/tariffManagement/isOpenDialog',
                false
            );
            this.clearFields();
        },
        submitTariff() {
            if (
                this.$store.state.ManagementBase.tariffManagement.formType ==
                'add'
            )
                this.$store.dispatch(
                    'ManagementBase/tariffManagement/addTariff'
                );
            else
                this.$store.dispatch(
                    'ManagementBase/tariffManagement/editTariff'
                );

            this.closeForm();
        },
    },
    computed: {
        filteredPromotions() {
            let filterIs_active = (item) => (item.is_active = true);
            let filterOperator = (item) =>
                this.operator ? item.operator == this.operator : true;

            return this.promotions.filter(
                (item) => filterIs_active(item) && filterOperator(item)
            );
        },
        filteredAdditionals() {
            let filterIs_active = (item) => (item.is_active = true);
            let filterOperator = (item) =>
                this.operator ? item.operator == this.operator : true;
            let filterSegment = (item) =>
                this.segment ? item.segment == this.segment : true;

            return this.additionals.filter(
                (item) =>
                    filterIs_active(item) &&
                    filterOperator(item) &&
                    filterSegment(item)
            );
        },
        filteredSva() {
            let filterIs_active = (item) => (item.is_active = true);
            let filterOperator = (item) =>
                this.operator ? item.operator == this.operator : true;
            let filterSegment = (item) =>
                this.segment ? item.segment == this.segment : true;

            return this.sva.filter(
                (item) =>
                    filterIs_active(item) &&
                    filterOperator(item) &&
                    filterSegment(item)
            );
        },
        isOpenDialog: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .isOpenDialog;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/isOpenDialog',
                    val
                );
                this.clearFields();
            },
        },
        name: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement.name;
            },
            set(val) {
                this.$store.commit('ManagementBase/tariffManagement/name', val);
            },
        },
        operator: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .operator;
            },
            set(val) {
                console.log(`Seteado ${val}`);
                this.$store.commit(
                    'ManagementBase/tariffManagement/operator',
                    val
                );
            },
        },
        category: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .category;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/category',
                    val
                );
            },
        },
        payment_type: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .payment_type;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/payment_type',
                    val
                );
            },
        },
        segment: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .segment;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/segment',
                    val
                );
            },
        },
        color: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement.color
                    ? this.$store.state.ManagementBase.tariffManagement.color
                          .charAt(0)
                          .toUpperCase() +
                          this.$store.state.ManagementBase.tariffManagement.color.slice(
                              1
                          )
                    : '';
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/color',
                    val.toLowerCase()
                );
            },
        },
        MobileForeignMinuteQuantity: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .MobileForeignMinuteQuantity;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/MobileForeignMinuteQuantity',
                    val
                );
            },
        },
        MobileNationalMinuteQuantity: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .MobileNationalMinuteQuantity;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/MobileNationalMinuteQuantity',
                    val
                );
            },
        },
        LandLineToLandLineMinuteQuantity: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .LandLineToLandLineMinuteQuantity;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/LandLineToLandLineMinuteQuantity',
                    val
                );
            },
        },
        LandLineToMobileMinuteQuantity: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .LandLineToMobileMinuteQuantity;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/LandLineToMobileMinuteQuantity',
                    val
                );
            },
        },
        DataQuantity: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .DataQuantity;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/DataQuantity',
                    val
                );
            },
        },
        MinuteQuantity: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .MinuteQuantity;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/MinuteQuantity',
                    val
                );
            },
        },
        // Upfront: {
        //     get() {
        //         return this.$store.state.ManagementBase.tariffManagement
        //             .Upfront;
        //     },
        //     set(val) {
        //         this.$store.commit(
        //             'ManagementBase/tariffManagement/Upfront',
        //             val
        //         );
        //     },
        // },
        price: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement.price;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/price',
                    val
                );
            },
        },
        UploadSpeedQuantity: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .UploadSpeedQuantity;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/UploadSpeedQuantity',
                    val
                );
            },
        },
        DownloadSpeedQuantity: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .DownloadSpeedQuantity;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/DownloadSpeedQuantity',
                    val
                );
            },
        },
        UploadSpeedUnit: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .UploadSpeedUnit;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/UploadSpeedUnit',
                    val
                );
            },
        },
        DownloadSpeedUnit: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .DownloadSpeedUnit;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/DownloadSpeedUnit',
                    val
                );
            },
        },
        DataUnit: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .DataUnit;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/DataUnit',
                    val
                );
            },
        },
        FiberType: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .FiberType;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/FiberType',
                    val
                );
            },
        },
        Owner: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement.Owner;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/Owner',
                    val
                );
            },
        },
        // formType: {
        //     get() {
        //         return this.$store.state.ManagementBase.tariffManagement
        //             .formType;
        //     },
        //     set(val) {
        //         this.$store.commit(
        //             'ManagementBase/tariffManagement/formType',
        //             val
        //         );
        //     },
        // },
        MaxNumber: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .MaxNumber;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/MaxNumber',
                    val
                );
            },
        },
        isActive: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .isActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/isActive',
                    val
                );
            },
        },
        isAdditional: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .isAdditional;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/isAdditional',
                    val
                );
            },
        },
        isEditableForm() {
            return this.formType == 'edit' || this.formType == 'watch';
        },
        SelectedPromotions: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement.SelectedPromotions.map(
                    (promotion) => promotion.id
                );
            },
            set(discountIds) {
                this.$store.state.ManagementBase.tariffManagement.SelectedPromotions =
                    [];

                discountIds.forEach((discountId) => {
                    this.$store.state.ManagementBase.tariffManagement.SelectedPromotions.push(
                        this.promotions.find(
                            (promotion) => promotion.id == discountId
                        )
                    );
                });
            },
        },
        SelectedAditionals: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement.SelectedAditionals.map(
                    (additional) => additional.name
                );
            },
            set(additionalNames) {
                this.$store.state.ManagementBase.tariffManagement.SelectedAditionals =
                    [];

                additionalNames.forEach((additionalName) => {
                    this.$store.state.ManagementBase.tariffManagement.SelectedAditionals.push(
                        this.additionals.find(
                            (additional) => additional.name == additionalName
                        )
                    );
                });
            },
        },
        SelectedSVA: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement.SelectedSVA.map(
                    (sva) => sva.id
                );
            },
            set(svaNames) {
                this.$store.state.ManagementBase.tariffManagement.SelectedSVA =
                    [];

                svaNames.forEach((additionalName) => {
                    this.$store.state.ManagementBase.tariffManagement.SelectedSVA.push(
                        this.sva.find((sva) => sva.id == additionalName)
                    );
                });
            },
        },
        FamiliaObjetivo: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .FamiliaObjetivo;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/FamiliaObjetivo',
                    val
                );
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        ...mapState('ManagementBase', {
            formType: (state) => state.baseForm.formType,
            tipoObjetivo: (state) => state.tipoObjetivo,
        }),
        ...mapState('ManagementBase/promotionManagement', {
            promotions: (state) => state.promotionManagement.promotions,
        }),
        ...mapState('ManagementBase/additionalManagement', {
            additionals: (state) => state.additionalManagement.additionals,
        }),
        ...mapState('ManagementBase/SVAManagement', {
            sva: (state) => state.SVAManagement.svas,
        }),
    },
    watch: {},
};
</script>

<style scoped>
</style>